import { getKeys } from './getKeys'

export const dailyLogsTranslations = {
  PARTIAL_RESULTS:
    'Not every log in this date range is shown. Choose a shorter range, or open Logs search to see them all.',
  OPEN_LOGS_SEARCH: 'Open Logs search',
  SHOW_MORE: 'Show more logs',
  PDF_PARTIAL_RESULTS:
    "This PDF doesn't include every log in this date range. Choose a shorter date range, or use Logs search for a full export."
}

export const dailyLogsConstants = getKeys(dailyLogsTranslations)
